import React from 'react';

/**
 * «CONSENSO DA FIRMARE» SULLA VISITA (Alex, 4/10/2026): al medico un avviso
 * sulla visita, non un compito; il compito va alla segreteria, che fa
 * firmare il paziente quando si presenta. Le righe le manda il server
 * (consensi_mancanti_della_visita, la stessa funzione del controllo della
 * segreteria): qui si disegnano e basta. Sono visite registrate prima che
 * il gestionale pretendesse il consenso, o col consenso firmato in una
 * visita poi finita nel cestino; una visita nuova non ci arriva, perche'
 * senza consenso la prestazione non si registra.
 */
const AvvisoConsensi = ({ righe }) => {
    if (!Array.isArray(righe) || righe.length === 0) return null;
    return (
        <div className="pd-avviso-consensi" role="status">
            <div className="pd-avviso-consensi-titolo">Consenso da firmare</div>
            <ul>
                {righe.map((c) => (
                    <li key={c.visita_prestazione_id}>
                        <b>{c.nome}</b>
                        {c.senza_modello
                            ? ': il medico che l\'ha eseguita non ha un modello di consenso assegnato. Lo assegna l\'amministrazione.'
                            : `: manca ${c.modelli ? `«${c.modelli}»` : 'il consenso'}.`}
                        {c.segno && ` Quello firmato prima porta il segno «${c.segno}».`}
                    </li>
                ))}
            </ul>
            <div className="pd-avviso-consensi-nota">
                Il paziente lo firma quando si presenta: la segreteria lo ha fra i suoi compiti.
                Si può far firmare anche da qui, con «Genera documento» nei documenti generati.
            </div>
        </div>
    );
};

export default AvvisoConsensi;
